import React from 'react';
import Layout from './layout';
import Routing from '../Routing';

function Body() {
  return (
    <Layout>
      <Routing />
    </Layout>
  );
}

export default Body;
